import { ArrowUpOutlined } from '@ant-design/icons';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import React from 'react';
import { Button } from 'src/app/components/base/Button';
export const NewPostsButton = ({ onClick, showButton }) => {
    const [parent] = useAutoAnimate();
    return (React.createElement("div", { ref: parent }, showButton && (React.createElement(Button, { type: "primary", shape: "round", icon: React.createElement(ArrowUpOutlined, null), size: "large", className: "fixed bottom-6 right-6", onClick: onClick }, "New content"))));
};
